function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/* eslint semi: ["error", "never"]*/

/* eslint key-spacing: ["error", { "afterColon": true, "align": "value" }] */
import React from 'react';
import { clearFlashMessage } from '@engine/actions/creators/flash-message';
import { connect } from 'react-redux';
var WAIT_COMPONENT_MOUNT = 500;
var DELAY_TIME = 5000;
var FADE_IN_CLASS = 'fade-in';
var FADE_OUT_CLASS = 'fade-out';

var FlashMessage = /*#__PURE__*/function (_React$Component) {
  _inherits(FlashMessage, _React$Component);

  var _super = _createSuper(FlashMessage);

  function FlashMessage(props) {
    var _this;

    _classCallCheck(this, FlashMessage);

    _this = _super.call(this, props);
    _this.state = {
      fadeClass: ''
    };
    return _this;
  }

  _createClass(FlashMessage, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this2 = this;

      if (this.props.content.length > 0 && this.state.fadeClass === '') {
        setTimeout(function () {
          return _this2.setState({
            fadeClass: FADE_IN_CLASS
          });
        }, WAIT_COMPONENT_MOUNT);
      }
    }
  }, {
    key: "setFade",
    value: function setFade() {
      if (this.state.fadeClass === FADE_IN_CLASS) {
        this.delayFadeOut();
      }

      if (this.state.fadeClass === FADE_OUT_CLASS) {
        this.dismissMessage();
      }
    }
  }, {
    key: "delayFadeOut",
    value: function delayFadeOut() {
      var _this3 = this;

      setTimeout(function () {
        return _this3.setState({
          fadeClass: FADE_OUT_CLASS
        });
      }, DELAY_TIME);
    }
  }, {
    key: "dismissMessage",
    value: function dismissMessage() {
      this.setState({
        fadeClass: ''
      });
      this.props.clearFlashMessage();
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      if (this.props.content.length === 0) {
        return null;
      }

      return React.createElement("div", {
        className: "fade-message flash alert alert-".concat(this.props.status, " ").concat(this.state.fadeClass),
        onAnimationEnd: function onAnimationEnd() {
          return _this4.setFade();
        }
      }, this.props.content.map(function (text) {
        return React.createElement("span", {
          key: "".concat(new Date()).concat(text)
        }, text);
      }));
    }
  }]);

  return FlashMessage;
}(React.Component);

var mapStateToProps = function mapStateToProps(state) {
  return {
    content: state.flashMessage.content,
    status: state.flashMessage.status
  };
};

export default connect(mapStateToProps, {
  clearFlashMessage: clearFlashMessage
})(FlashMessage);